<template>
  <div class="page-container flex-container">
    <ModalBox :visible="showModal" :infoTitle="infoTitle" :infoMessage="infoMessage" @close="showModal = false" />
    <!-- <div class="page-header">
        <CustomAnimatedLogo></CustomAnimatedLogo>
    </div> -->

    
    <CustomAnimatedLogo v-if="isInProgress"></CustomAnimatedLogo>
    <div v-if="!isInProgress" class="container">
      <br>
      <h5 class="flex-container">Experimental Projects</h5>
      <div class="info-disclaimer">
        <p>Projects on this page are being developed <span class="important-context">in a fast-paced environment</span> and may not be mature</p>
      </div>
    </div>
    <div class="content-box">
      <LabItem 
            title="Data Extractor" 
            description="Extract data from the system to a file in any standardized format."
            >
            <template #button>
                <router-link to="/lab/data-extractor" class="btn">Open</router-link>
            </template>
      </LabItem>
        <LabItem 
            title="Data Visualizer"
            description="Visualize data from a given file in a chart or a table."
            statusText="[ Coming Soon ]"
            >
            <template #button>
              <button class="btn" @click="handleClick">Open</button>
            </template>
      </LabItem>
        <LabItem 
            title="Sales Simulator" 
            description="Simulate ROI and savings using historical data, user input and other parameters."
            >
            <template #button>
                <router-link to="/lab/simulator" class="btn">Open</router-link>
            </template>
        </LabItem>
    </div>
    <div class="custom-divider"></div>
      <div class="content-box">
        <LabItem 
            title="PV Generation Estimator" 
            description="Estimate the PV generation of a location using weather data and other parameters."
            >
            <template #button>
              <router-link to="/lab/pv-generation-estimator" class="btn">Open</router-link>
            </template>
      </LabItem>
        <LabItem 
            title="Optimal Battery Size Estimator" 
            description="Estimate optimal battery size on the base of given data parameters."
            >
            <template #button>
              <!-- <button class="btn" @click="handleClick">Open</button> -->
              <router-link to="/lab/battery-size-estimator" class="btn">Open</router-link>
            </template>
      </LabItem>
      <LabItem 
            title="AI Onboarding Evaluator" 
            description="Evaluate the onboarding of current Renox customer for AI Control eligibility."
            statusText=""
            >
             <template #button>
                <router-link to="/lab/ai-onboarding-evaluator" class="btn">Open</router-link>
            </template>
      </LabItem>



    </div>

  </div>
  <div class="custom-divider"></div>
</template>

<script>
import { ref, nextTick } from 'vue';
import { apiRequest } from '@/services/apiService';
import { Chart } from 'chart.js';
import ModalBox from '@/components/cards/ModalBox.vue';
import LabItem from '@/components/cards/LabItem.vue';
import CustomAnimatedLogo from '../cards/CustomAnimatedLogo.vue';
import StyledInfoBox from '../cards/StyledInfoBox.vue';
import VueApexCharts from 'vue3-apexcharts';
import StyledInfoWithIcon from '../cards/StyledInfoWithIcon.vue';
import AiOnboardingEvaluatorPage from '@/components/pages/AiOnboardingEvaluatorPage.vue';

const showModal = ref(false);
const infoTitle = ref('');
const infoMessage = ref('');

// Function to convert file to base64
const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result.split(',')[1]); // Remove data URL prefix
    reader.onerror = (error) => reject(error);
  });
};

export default {
  name: 'SimulatorPage',
  components: {
    ModalBox,
    CustomAnimatedLogo,
    StyledInfoBox,
    VueApexCharts,
    StyledInfoWithIcon,
    LabItem,
    AiOnboardingEvaluatorPage
  },
  computed: {

  },
  methods: {
    handleClick() {
      alert("This feature is under development and coming soon!");
    },
  },
  setup() {
    const isInProgress = ref(false);
    const showModal = ref(false);
    const infoTitle = ref('');
    const infoMessage = ref('');



    return {
        showModal,
        infoTitle,
        infoMessage,
        isInProgress,
      
    };
  },
};
</script>

<style scoped>
.page-header {
  display: flex; /* Optional: Align child properly */
  justify-content: center;
  align-items: center;
  height: 100px; /* Set a specific height for the header */
  width: 100px;
}
.important-context {
  font-weight: bold;
}
.info-disclaimer {
  margin-top: 1rem;
  padding: 1rem;
  background-color: var(--bg-secondary);
  color: var(--text-primary);
  border: 1px solid var(--border-color);
  border-radius: 0.5rem;
  text-align: center;
}
.content-box {
  display: flex; /* Optional: Align child properly */
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin: 0;
}

.custom-divider {
  height: 36px;
  margin: 0;
}

.btn {
    background: var(--custom-color1);
    border: none;
    color: white;
    cursor: pointer;
}

.btn:disabled {
    color: gray;
    text-decoration: none;
    cursor: not-allowed;
}


@media (max-width: 750px) {
  .content-box {
    flex-direction: column;
  }

  .custom-divider {
    height: 20px;
  }


}

</style>
